import { useState } from "react";
export const usePages = (imagesPerPage, categories) => {
    const [currentPage, setCurrentPage] = useState(0);
    const finalImgIndex = (currentPage + 1) * imagesPerPage;
    const begginingImgIndex = currentPage * imagesPerPage;
    let index = 0;
    const displayableCategories = categories
        .map((category, i) => {
        return {
            ...category,
            images: category.images.filter((_) => {
                index++;
                return index >= begginingImgIndex && index <= finalImgIndex;
            }),
            index: i,
        };
    })
        .filter((category) => category.images.length > 0);
    const pagesCount = Math.ceil(categories.reduce((acc, category) => acc + category.images.length, 0) /
        imagesPerPage);
    return {
        currentPage,
        setCurrentPage,
        displayableCategories,
        pages: pagesCount,
    };
};
